import {modal} from "./modal";
import {tooltip} from "./tooltip";
import {collapse} from "./collapse";
import {popover} from "./popover";
import {tab} from "./tab";
import {transition} from "./transition";
import {carousel} from "./carousel";

export function bootstrap($) {
    transition($);
    carousel($, globalBootstrapIsAbsent);
    modal($, globalBootstrapIsAbsent);
    tooltip($);
    popover($);
    collapse($, globalBootstrapIsAbsent);
    tab($, globalBootstrapIsAbsent);
};

function globalBootstrapIsAbsent() {
    return window.jQuery.fn.emulateTransitionEnd == undefined;
}
